// import thumbnail_1 from '../../assets/images/no-image.jpg'
// import thumbnail_2 from '../../assets/images/no-image.jpg'
// import thumbnail_3 from '../../assets/images/no-image.jpg'
import thumbnail_4 from '../../assets/SloveApp/thumbnail.png'

import image0 from '../SloveApp/0.webp'
import image1 from '../SloveApp/1.webp'
import image2 from '../SloveApp/2.webp'
import image3 from '../SloveApp/3.webp'
import image4 from '../SloveApp/4.webp'
import image5 from '../SloveApp/5.webp'
import image6 from '../SloveApp/6.webp'

export const solveApp = {
  id:9,
  type:'mobile',
  thumbnails: [thumbnail_4],
  screens: [image0, image1, image2, image3, image4, image5, image6],
  title: 'Welcome to SLOVE – Your Ultimate Destination for Streaming, Sharing, and Discovering Music Worldwide',
  intro: "Embark on an unparalleled musical adventure with SLOVE – the all-in-one music platform tailored for artists, creators, and passionate listeners. From discovering trending tracks to sharing your original music with the world, SLOVE redefines how you experience sound. Let’s explore the design, features, and interactive interface that make SLOVE the go-to app for all things music.",
  features: [
    {
      title: "Sleek and Immersive UI Design",
      description: "SLOVE features a modern, visually rich interface designed to elevate user interaction. With vibrant gradients, smooth transitions, and intuitive layouts, users are welcomed into a premium listening and sharing experience."
    },
    {
      title: "Discover and Stream Unlimited Music",
      description: "Browse through a vast library of songs, albums, and curated playlists across genres. Whether you're into indie, electronic, hip-hop, or classical, SLOVE makes discovering new music effortless and fun."
    },
    {
      title: "Artist Profiles and Music Uploads",
      description: "Emerging and established artists can create stunning profiles, upload tracks, albums, and connect with fans. SLOVE supports high-quality audio uploads, cover art, and social integration."
    },
    {
      title: "Smart Recommendations and Personalized Playlists",
      description: "Powered by intelligent algorithms, SLOVE learns your taste and delivers tailored playlists and song suggestions based on your listening habits."
    },
    {
      title: "Live Sessions and Interactive Streaming",
      description: "Join live audio sessions, stream performances, or host your own listening parties. Real-time reactions, chat, and co-listening features bring artists and fans closer than ever."
    },
    {
      title: "Social Sharing and Community Building",
      description: "Follow other users, like and comment on tracks, and build your own music community. Share your favorite songs directly to social media or with friends in-app."
    },
    {
      title: "Achievements and Listener Badges",
      description: "Gamify your music journey with badges for top listener, playlist curator, and artist supporter. Unlock milestones as you engage more with the platform."
    }
  ],
  conclusion: "SLOVE isn’t just a music app – it's a lifestyle. Whether you're creating, exploring, or just vibing, SLOVE brings music lovers and artists together in one powerful, beautifully designed space. Dive into SLOVE today and amplify your sound!"
}
